import { Box, Paper } from '@mui/material';
import React from 'react';

interface CertificateProps {
  certificateNumber: string;
  unitType: string;
  unitHolder: string;
  units: number;
  price: number;
  date: string;
  beneficiary: string;
  trustee: string;
  dateOfRegistration: string;
  executionDate: string;
  action: 'certificate' | 'application';
  trustName: string;
  trustDeedExecutionDate: string;
  trustFundManagerSignatureBase64?: string | null;
  investorSignatureBase64?: string | null;
}

const CertificateTemplate: React.FC<CertificateProps> = ({
  certificateNumber,
  unitType,
  unitHolder,
  units,
  price,
  date,
  beneficiary,
  trustee,
  dateOfRegistration,
  executionDate,
  action,
  trustName,
  trustDeedExecutionDate,
  trustFundManagerSignatureBase64,
  investorSignatureBase64
}) => {
  const a4Width = 210;
  const a4Height = 297;

  console.log("price",price)

  console.log("price",price)

  // Use investor signature for application, trust fund manager signature for certificate
  const signatureSrc =
    action === 'application' ? investorSignatureBase64 : trustFundManagerSignatureBase64;

  // console.log('Rendering CertificateTemplate signatureSrc:', signatureSrc);
  // console.log('Rendering CertificateTemplate signatureSrc:', signatureSrc);
  if (action === 'application') {
    return (
      <Paper
        elevation={0}
        sx={{
          width: `${a4Width}mm`,
          minHeight: `${a4Height}mm`,
          padding: '15mm',
          boxSizing: 'border-box',
          backgroundColor: '#ffffff',
          fontFamily: 'Arial, sans-serif',
          color: '#000',
          border: '2px solid #000',
          '@media print': {
            border: '2px solid #000'
          }
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: '#808080',
            color: '#ffffff',
            textAlign: 'center',
            padding: '8mm 0',
            marginBottom: '8mm'
          }}
        >
          <Box
            sx={{
              fontSize: '18pt',
              fontStyle: 'italic',
              fontWeight: 'bold',
              marginBottom: '2mm'
            }}
          >
            Application for Units
          </Box>
          <Box sx={{ fontSize: '16pt', fontStyle: 'italic', fontWeight: 'bold' }}>{trustName}</Box>
        </Box>

        {/* To the trustee */}
        <Box sx={{ marginBottom: '8mm' }}>
          <Box sx={{ fontSize: '11pt', marginBottom: '5mm' }}>To the trustee</Box>
          <Box sx={{ fontSize: '10pt', lineHeight: 1.6, textAlign: 'justify' }}>
            As unit holders, we hereby apply for units as specified in table below in {trustName}{' '}
            established by deed on {trustDeedExecutionDate} and agree to be bound by the terms of
            the Deed and to hold such Units to the terms and conditions in the Deed. We request the
            trustee to allot us the units and register our name in the unit holder register.
          </Box>
        </Box>

        {/* Table with populated data */}
        <Box sx={{ border: '2px solid #000', marginBottom: '10mm' }}>
          {/* Table rows */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              borderBottom: '2px solid #000'
            }}
          >
            <Box
              sx={{
                padding: '4mm',
                borderRight: '2px solid #000',
                fontWeight: 'bold',
                fontSize: '11pt'
              }}
            >
              Type of unit
            </Box>
            <Box sx={{ padding: '4mm', fontWeight: 'bold', fontSize: '11pt' }}>
              Number of units applied
            </Box>
          </Box>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              borderBottom: '2px solid #000'
            }}
          >
            <Box
              sx={{
                padding: '4mm',
                borderRight: '2px solid #000',
                fontSize: '10pt'
              }}
            >
              Fully paid units of ${Number(price)?.toFixed(2)} each
            </Box>
            <Box sx={{ padding: '4mm', fontSize: '10pt', fontWeight: 'bold' }}>
              {units.toFixed(2)}
            </Box>
          </Box>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              borderBottom: '2px solid #000',
              minHeight: '25mm'
            }}
          >
            <Box
              sx={{
                padding: '4mm',
                borderRight: '2px solid #000',
                fontWeight: 'bold',
                fontSize: '11pt'
              }}
            >
              The units will be held by
            </Box>
            <Box sx={{ padding: '4mm', fontSize: '10pt', fontWeight: 'bold' }}>{unitHolder}</Box>
          </Box>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              minHeight: '25mm'
            }}
          >
            <Box
              sx={{
                padding: '4mm',
                borderRight: '2px solid #000',
                fontWeight: 'bold',
                fontSize: '11pt'
              }}
            >
              The Beneficial owner of units is
            </Box>
            <Box sx={{ padding: '4mm', fontSize: '10pt', fontWeight: 'bold' }}>{beneficiary}</Box>
          </Box>
        </Box>

        {/* Date and Signature */}
        <Box sx={{ marginTop: '15mm' }}>
          <Box sx={{ display: 'flex', marginBottom: '8mm', alignItems: 'center' }}>
            <Box sx={{ fontSize: '10pt', marginRight: '5mm' }}>Date:</Box>
            <Box
              sx={{
                flex: 1,
                borderBottom: '1px solid #000',
                marginRight: '10mm',
                paddingBottom: '2mm',
                fontSize: '10pt',
                fontWeight: 'bold'
              }}
            >
              {date}
            </Box>
          </Box>

          <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '2mm' }}>
            <Box sx={{ fontSize: '10pt', marginRight: '5mm' }}>Signature:</Box>
            {signatureSrc ? (
              <img
                src={signatureSrc}
                alt="signature"
                style={{ display: 'block', maxHeight: '30mm', maxWidth: '80mm' }}
              />
            ) : (
              <Box
                sx={{
                  flex: 1,
                  borderBottom: '1px solid #000',
                  marginRight: '10mm',
                  height: '8mm'
                }}
              />
            )}
          </Box>
        </Box>

        {/* Bottom border box */}
        <Box sx={{ marginTop: '10mm', border: '2px solid #000', minHeight: '15mm' }}></Box>
      </Paper>
    );
  }

  // Certificate view (after acceptance)
  return (
    <Paper
      elevation={0}
      sx={{
        width: `${a4Width}mm`,
        minHeight: `${a4Height}mm`,
        padding: '15mm',
        boxSizing: 'border-box',
        backgroundColor: '#ffffff',
        fontFamily: 'Arial, sans-serif',
        color: '#000',
        border: '2px solid #000',
        '@media print': {
          border: '2px solid #000'
        }
      }}
    >
      {/* Header */}
      <Box
        sx={{
          backgroundColor: '#808080',
          color: '#ffffff',
          textAlign: 'center',
          padding: '8mm 0',
          marginBottom: '8mm'
        }}
      >
        <Box
          sx={{
            fontSize: '18pt',
            fontStyle: 'italic',
            fontWeight: 'bold',
            marginBottom: '2mm'
          }}
        >
          Unit Certificate
        </Box>
        <Box sx={{ fontSize: '16pt', fontStyle: 'italic', fontWeight: 'bold' }}>{trustName}</Box>
      </Box>

      {/* Certificate Number */}
      <Box
        sx={{
          textAlign: 'right',
          fontSize: '11pt',
          marginBottom: '8mm',
          fontWeight: 'bold'
        }}
      >
        Certificate Number : #{certificateNumber}
      </Box>

      {/* Main text */}
      <Box sx={{ fontSize: '10pt', lineHeight: 1.6, marginBottom: '8mm', textAlign: 'justify' }}>
        This is to certify that the table below is the registered holder of the number of units
        below mentioned in the {trustName} trust constituted by the trust deed dated{' '}
        {trustDeedExecutionDate} and entered in the Register of Unit holders on the{' '}
        {dateOfRegistration}.
      </Box>

      {/* Table */}
      <Box sx={{ border: '2px solid #000', marginBottom: '10mm' }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            borderBottom: '2px solid #000'
          }}
        >
          <Box
            sx={{
              padding: '4mm',
              borderRight: '2px solid #000',
              fontWeight: 'bold',
              fontSize: '11pt'
            }}
          >
            Type of unit
          </Box>
          <Box sx={{ padding: '4mm', fontWeight: 'bold', fontSize: '11pt' }}>Number of units</Box>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            borderBottom: '2px solid #000'
          }}
        >
          <Box
            sx={{
              padding: '4mm',
              borderRight: '2px solid #000',
              fontSize: '10pt'
            }}
          >
            Fully paid {unitType} units of ${price.toFixed(3)} each
          </Box>
          <Box sx={{ padding: '4mm', fontSize: '10pt', fontWeight: 'bold' }}>
            {units.toFixed(3)}
          </Box>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            borderBottom: '2px solid #000',
            minHeight: '25mm'
          }}
        >
          <Box
            sx={{
              padding: '4mm',
              borderRight: '2px solid #000',
              fontWeight: 'bold',
              fontSize: '11pt'
            }}
          >
            The units will be held by
          </Box>
          <Box sx={{ padding: '4mm', fontSize: '10pt', fontWeight: 'bold' }}>{unitHolder}</Box>
        </Box>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            minHeight: '25mm'
          }}
        >
          <Box
            sx={{
              padding: '4mm',
              borderRight: '2px solid #000',
              fontWeight: 'bold',
              fontSize: '11pt'
            }}
          >
            The Beneficial owner of units
          </Box>
          <Box sx={{ padding: '4mm', fontSize: '10pt', fontWeight: 'bold' }}>{beneficiary}</Box>
        </Box>
      </Box>

      {/* Signature section */}
      <Box sx={{ marginTop: '15mm' }}>
        <Box sx={{ fontSize: '11pt', fontWeight: 'bold', marginBottom: '5mm' }}>
          Signed for and on behalf of the Trustee
        </Box>

        <Box sx={{ display: 'flex', marginBottom: '8mm', alignItems: 'center' }}>
          <Box sx={{ fontSize: '10pt', marginRight: '5mm', minWidth: '20mm' }}>Date:</Box>
          <Box
            sx={{
              flex: 1,
              borderBottom: '1px solid #000',
              marginRight: '10mm',
              paddingBottom: '2mm',
              fontSize: '10pt',
              fontWeight: 'bold'
            }}
          >
            {dateOfRegistration}
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
          <Box sx={{ fontSize: '10pt', marginRight: '5mm', minWidth: '20mm' }}>Signature:</Box>
          {signatureSrc ? (
            <img
              src={signatureSrc}
              alt="signature"
              style={{ maxHeight: '30mm', maxWidth: '80mm' }}
            />
          ) : (
            <Box
              sx={{
                flex: 1,
                borderBottom: '1px solid #000',
                marginRight: '10mm',
                height: '8mm'
              }}
            />
          )}
        </Box>
      </Box>

      {/* Important section */}
      <Box
        sx={{
          marginTop: '12mm',
          border: '2px solid #000',
          padding: '5mm'
        }}
      >
        <Box sx={{ fontSize: '11pt', fontWeight: 'bold', marginBottom: '3mm' }}>Important</Box>
        <Box sx={{ fontSize: '9pt', fontStyle: 'italic', lineHeight: 1.5 }}>
          Please note that the trust deed imposes restrictions to transfer these units and this
          certificate must be attached to application to transfer any units comprised therein.
        </Box>
      </Box>
    </Paper>
  );
};

export default CertificateTemplate;
